import React, { Component } from 'react';
import { Icon, Menu } from 'semantic-ui-react';

class RendersNavbar extends Component {
  render() {
    return (
      <Menu secondary>
        <Menu.Item>
          <Icon name="image" />
          TODO
        </Menu.Item>
      </Menu>
    );
  }
}

export default RendersNavbar;
